import { render } from "./assemble.vue?vue&type=template&id=7cea0a0c"
import script from "./assemble.vue?vue&type=script&lang=js"
export * from "./assemble.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__